import { useState, useEffect } from "react";
import { Modal, Form, Input } from "antd";
import { ShowToast, Severty } from "../../helper/toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import callApi from "../../constants/API/CallApi";
import { updateEmail } from "../../constants/API/API";

const EmailUpdate = ({
  editVisible,
  setEditVisible,
  selectedEmail,
  refresh,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (selectedEmail) {
      form.setFieldsValue(selectedEmail);
    }
  }, [selectedEmail, form]);

  const handleOk = async (values) => {
    setLoading(true);
    callApi({
      callback: updateEmail,
      payload: [values, selectedEmail._id],
      onSuccess: ({ message }) => {
        refresh(new Date().getTime());
        ShowToast(message, Severty.SUCCESS);
        setEditVisible(false);
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const handleCancel = () => {
    setEditVisible(false);
  };

  const validateName = (rule, value) => {
    if (!value) {
      return Promise.reject("Please enter a name");
    } else if (!/^[A-Z][a-zA-Z ]*$/.test(value)) {
      return Promise.reject(
        "Name must start with a capital letter and contain only letters"
      );
    } else {
      return Promise.resolve();
    }
  };

  return (
    <Modal
      className="tab_modal"
      title="Update Email"
      visible={editVisible}
      okButtonProps={{
        htmlType: "submit",
        form: "edit-email",
        loading: loading,
      }}
      onCancel={handleCancel}
      afterClose={() => form.resetFields()}
    >
      <Form
        id="edit-email"
        onFinish={handleOk}
        form={form}
        layout="vertical"
        initialValues={selectedEmail}
      >
        <Form.Item
          name="name"
          label="Title"
          rules={[
            { required: true, message: "Please enter the title" },
            { validator: validateName },
          ]}
        >
          <Input placeholder="Enter title" />
        </Form.Item>
        <Form.Item
          name="subject"
          label="Subject"
          rules={[
            { required: true, message: "Please enter the subject" },
            { validator: validateName },
          ]}
        >
          <Input placeholder="Enter subject" />
        </Form.Item>
        <Form.Item
          label="Description"
          name="description"
          className="short try col-12"
          style={{ marginTop: "10px" }}
        >
          <ReactQuill
            placeholder="Enter description here..."
            value={description}
            onChange={setDescription}
            modules={{
              toolbar: [
                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                ["bold", "italic", "underline", "strike", "blockquote"],
                [{ list: "ordered" }, { list: "bullet" }],
                ["clean"],
              ],
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EmailUpdate;
